import classNames from 'classnames'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class TabItem extends Component {
  static propTypes = {
    href: PropTypes.string,
    isSelected: PropTypes.bool.isRequired,
    onSelect: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
  }

  static defaultProps = {
    isSelected: false
  }

  render() {
    const { isSelected, href, onSelect, title } = this.props
    const classes = classNames('qv-tab', {
      'qv-tab-is-selected': isSelected
    })

    if (href) {
      return (
        <Link to={href} className={classes}>
          {I18n.t(title)}
        </Link>
      )
    }

    return (
      <div className={classes} onClick={onSelect}>
        {I18n.t(title)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/TabItem.js